import {
  APP_MODAL_ROUTES,
  DSR_TOOLING_ROUTES,
  ORDER_INBOUNDS_ROUTES,
} from '@/navigators/routes';
import {
  AppModalStackParams,
  DSRToolingParams,
  OrderInboundsStackParams,
} from '@/navigators/types';
import {
  CompositeNavigationProp,
  useNavigation,
} from '@react-navigation/native';
import { Platform } from 'react-native';
import { StackNavigationProp } from '@react-navigation/stack';
import { useCallback } from 'react';
import { useLayoutContext } from '@/contexts/layout-context';
import { useOrderInboundsStore } from '@/stores/order-inbounds-store';

type Navigation = CompositeNavigationProp<
  StackNavigationProp<AppModalStackParams, APP_MODAL_ROUTES.DSRTooling>,
  StackNavigationProp<
    OrderInboundsStackParams,
    ORDER_INBOUNDS_ROUTES.DSRTooling
  >
>;
export const useNavigateToDSRTooling = () => {
  const { isSmallLayout } = useLayoutContext();
  const navigation = useNavigation<Navigation>();

  return useCallback(
    (params: DSRToolingParams) => {
      const shouldNavigate = isSmallLayout && Platform.OS !== 'web';

      if (!shouldNavigate) {
        return false;
      }
      if (useOrderInboundsStore.getState().isInOrderInboundsStack) {
        navigation.navigate(ORDER_INBOUNDS_ROUTES.DSRTooling, params);
      } else {
        navigation.navigate(APP_MODAL_ROUTES.DSRTooling, {
          params,
          screen: DSR_TOOLING_ROUTES.Base,
        });
      }
      return true;
    },
    [isSmallLayout, navigation],
  );
};
